import React from 'react'
import TFA from '../TFA/index.jsx'
import MaskedInputWrap from '../maskedInputWrap.jsx'
import PhoneNumber from '../PhoneNumber/index.jsx'
import createAutoCorrectedDatePipe from '../Passport/autoCorrectedDatePipe'

const autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy/mm/dd', {
    maxYear: new Date().getFullYear(),
})

const FormatDataInput = props => {
    const translation = JSON.parse(localStorage.translation)[localStorage.language]
    let {
        item,
        profileDataParams,
        phoneVerificationRequired,
        dataProtection,
        profileDataChange,
    } = props

    if (item.key === 'phone') {
        return (
            <PhoneNumber
                currentData={item}
                phoneVerificationRequired={phoneVerificationRequired}
                dataProtection={dataProtection}
            />
        )
    } else if (
        item.key === 'passport-series_number' ||
        item.key === 'passport-date_issue'
    ) {
        return (
            <MaskedInputWrap
                type={item.key}
                readOnly={item.readOnly}
                value={profileDataParams[item.key]}
                changeValue={event => {
                    profileDataChange(item, event)
                }}
                placeholder={translation[item.title]}
                pipe={
                    item.key === 'passport-date_issue'
                        ? autoCorrectedDatePipe
                        : null
                }
            />
        )
    } else {
        return (
            <input
                value={profileDataParams[item.key]}
                type={item.key.indexOf('password') >= 0 ? 'password' : ''}
                onChange={event => {
                    profileDataChange(item, event)
                }}
                placeholder={translation[item.title]}
                readOnly={item.readOnly}
            />
        )
    }
}

export default FormatDataInput
